import { render } from "./SearchManagement.vue?vue&type=template&id=25fa3cd4&scoped=true"
import script from "./SearchManagement.vue?vue&type=script&lang=js"
export * from "./SearchManagement.vue?vue&type=script&lang=js"

import "./SearchManagement.vue?vue&type=style&index=0&id=25fa3cd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25fa3cd4"]])

export default __exports__